import {
  ForgotPasswordContainer,
  ForgotPasswordInput,
  ForgotPasswordProvider,
  ForgotPasswordSubmitButton,
  ForgotPasswordTitle,
} from "../forgotPassword";

export const ResetPasswordForm = () => {
  return (
    <ForgotPasswordProvider>
      <ForgotPasswordContainer>
        <ForgotPasswordTitle />
        <ForgotPasswordInput />
        <ForgotPasswordSubmitButton />
      </ForgotPasswordContainer>
    </ForgotPasswordProvider>
  );
};
